// 下からふわっとフェードイン
$(function(){
	$(window).scroll(function (){
		$('.js-fade').each(function(){
			var pos = $(this).offset().top;
			var scroll = $(window).scrollTop();
			var windowHeight = $(window).height();
			if (scroll > pos - windowHeight + 150){
				$(this).addClass('scroll');
			}
		});
	});
    $(document).ready(function() {
        $('.js-fade__first').addClass('scroll');
    });
});


